// Chakra imports
import { Box, Flex, Heading, Icon, IconButton, Text, useColorModeValue } from '@chakra-ui/react';
import Card from 'components/card/Card';
import { FaSquareXTwitter } from 'react-icons/fa6';
import { FiInstagram } from 'react-icons/fi';
import { TbBrandYoutubeFilled } from 'react-icons/tb';
import { SlGlobe } from "react-icons/sl";
import AvatarInput from 'views/trader/components/inputs/AvatarInput';
import { useState } from 'react';

export default function MentorBannerEdit(props: {
  banner: string;
  avatar: string;
  name: string;
  username: string;
  description: string;
  strategies: string;
  s_show: boolean;
  trades: string;
  t_show: boolean;
  journals: string;
  j_show: boolean;
  x_url: string;
  y_url: string;
  i_url: string;
  w_url: string;
  updateAvatar: any;
  [x: string]: any;
}) {

  const { banner, avatar, name, username, description, strategies, s_show, trades, t_show, journals, j_show, x_url, y_url, i_url, w_url, updateAvatar, ...rest } = props;
  // Chakra Color Mode
  const textColorPrimary = useColorModeValue('secondaryGray.900', 'white');
  const bgcolor = useColorModeValue('white', 'navy.800');
  const textColorSecondary = 'gray.400';
  /*const borderColor = useColorModeValue(
    'white !important',
    '#111C44 !important',
  );*/
  const [avatarsrc, setavatarsrc] = useState(avatar);

  const openSocial = (url: string) => {
    window.open("https://" + url, '_blank')
  }
  const saveAvatar = (src: string) => {
    setavatarsrc(src);
    updateAvatar(src);
  }

  return (
    <Card mb={{ base: '0px', lg: '20px' }} alignItems="center" {...rest}>
      <Box bgGradient="linear(to-b, brand.400, brand.600)" bgSize="cover" borderRadius="16px" h="90px" w="100%">
        <Flex w='100%' justify={'center'}>
          <IconButton hidden={!x_url.trim().length} aria-label={''} bg='transparent' icon={<Icon as={FaSquareXTwitter} boxSize={7} color={'white'} />} onClick={() => openSocial(x_url)} />
          <IconButton hidden={!y_url.trim().length} aria-label={''} bg='transparent' icon={<Icon as={TbBrandYoutubeFilled} boxSize={7} color={'white'} />} onClick={() => openSocial(y_url)} />
          <IconButton hidden={!i_url.trim().length} aria-label={''} bg='transparent' icon={<Icon as={FiInstagram} boxSize={7} color={'white'} />} onClick={() => openSocial(i_url)} />
          <IconButton hidden={!w_url.trim().length} aria-label={''} bg='transparent' icon={<Icon as={SlGlobe} boxSize={7} color={'white'} />} onClick={() => openSocial(w_url)} />
        </Flex>
      </Box>
      <AvatarInput image={avatarsrc} saveimage={saveAvatar} />
      {/*<Avatar mx="auto" cursor={'pointer'} src={avatar} h="87px" w="87px" mt="-43px" border="4px solid" borderColor={borderColor} onClick={()=>alert("CLICK")}/>*/}
      <Text color={textColorPrimary} fontWeight="bold" fontSize="xl" mt="10px">
        {name}
      </Text>
      <Text color={textColorSecondary} fontSize="sm" fontWeight={'700'}>
        {username}
      </Text>
      <Card borderWidth={'1px'} w='75%' mt='30px' hidden={!s_show && !t_show && !j_show}>
        <Flex justify={'center'}>
          <Heading size={'xs'} mt='-30px' bg={bgcolor} px='10px' color={textColorSecondary}>Shared</Heading>
        </Flex>
        <Flex w="100%" justify={'center'} direction={'row'} >
          <Flex mx="auto" align="center" direction="column" hidden={!s_show}>
            <Text color={textColorPrimary} fontSize="2xl" fontWeight="700">
              {strategies}
            </Text>
            <Text color={textColorSecondary} fontSize="sm" fontWeight="400">
              Strategies
            </Text>
          </Flex>
          <Flex mx="auto" align="center" direction="column" hidden={!t_show}>
            <Text color={textColorPrimary} fontSize="2xl" fontWeight="700">
              {trades}
            </Text>
            <Text color={textColorSecondary} fontSize="sm" fontWeight="400">
              Trades
            </Text>
          </Flex>
          <Flex mx="auto" align="center" direction="column" hidden={!j_show}>
            <Text color={textColorPrimary} fontSize="2xl" fontWeight="700">
              {journals}
            </Text>
            <Text color={textColorSecondary} fontSize="sm" fontWeight="400">
              Journals
            </Text>
          </Flex>
        </Flex>
      </Card>

      <Flex w="100%" mt="35px" justify={'center'}>
        <Box textAlign={'center'}>
          <Text color={textColorSecondary}>{description}</Text>
        </Box>
      </Flex>
    </Card>
  );
}
